import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Navigation from './Navigation';
import { SignalRMessageLogger } from '../SignalRTester';
import SignalRTestPanel from '../Testing/SignalRTestPanel';
import { useGame } from '../../contexts/GameContext';

export default function Layout() {
  const { gameSession } = useGame();
  const [showSignalRTestPanel, setShowSignalRTestPanel] = useState<boolean>(false);
  const showSignalRDebugTools = import.meta.env.DEV && window.location.search.includes('signalrDebug=1');

  return (
    <div className="min-vh-100 bg-light">
      <Navigation />

      <main>
        <Outlet />
      </main>

      <footer className="bg-dark text-white py-4 mt-auto">
        <Container>
          <div className="row">
            <div className="col-md-6">
              <h5 className="text-primary">
                <i className="fas fa-gamepad me-2"></i>
                TriviYolo
              </h5>
              <p className="mb-0">The ultimate multiplayer trivia experience.</p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="d-flex justify-content-md-end gap-3">
                <a href="#" className="text-white-50 text-decoration-none">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" className="text-white-50 text-decoration-none">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="#" className="text-white-50 text-decoration-none">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
              <p className="mb-0 small text-white-50 mt-2">
                Copyright 2026 TriviYolo. Built for live trivia nights.
              </p>
            </div>
          </div>
        </Container>
      </footer>

      {showSignalRDebugTools && (
        <>
          <SignalRTestPanel
            gameSessionId={gameSession?.id || null}
            gameSession={gameSession}
            isVisible={showSignalRTestPanel}
            onToggleVisibility={() => setShowSignalRTestPanel(!showSignalRTestPanel)}
          />
          <SignalRMessageLogger />
        </>
      )}
    </div>
  );
}
